<ion-textarea
  placeholder="Máximo 140 Caracteres"
  (ionInput)="reviewChange($event)"
  [disabled]="isEnabled"
  maxlength="140"
  mode="md"
></ion-textarea>

<p>{{ tamano }}/140</p>
